import type { Pending, PlayerId } from "../api/types";

export type OpenZone =
  | "deck"
  | "graveyard"
  | "exile"
  | "opp_graveyard"
  | "opp_exile"
  | "reveal"
  | null;

export function shouldAcknowledgeRevealClose(
  openZone: OpenZone,
  pending: Pending | null,
  viewer: PlayerId,
): boolean {
  return (
    openZone === "reveal" &&
    pending?.kind === "target" &&
    pending.player === viewer &&
    pending.request.min === 0 &&
    pending.request.max === 0
  );
}
